import {initOpenChatbot} from "Packages/Plugins/Avency.MercuryAi/Resources/Private/Assets/JavaScript/OpenChatbot";
import PageLoadedQueue from "./PageLoadedQueue";

PageLoadedQueue.addFunction(initOpenChatbot);
